import React from 'react';

import mm from '../../Assets/mm.png';

import style from './style.module.scss';
import { connectWallet } from '../../Utils/blockchainHelper';
import { useDispatch } from 'react-redux';
import { saveWallet, setWallet } from '../../Containers/Client/action';
import { showPopup } from '../../Containers/App/action';
import { toast } from 'react-toastify';

function WalletList({username}) {
    const dispatch = useDispatch()
    const walletData  = [
        {provider: 'mm', title: 'Metamask', icon: mm },
        // {provider: 'wc', title: 'Wallet Connect', icon: wc},
        // {provider: 'cbw', title: 'Coinbase Wallet', icon: cbw},
    ];
    const callback = (wallet) => {
        const cbSetWallet = (address) => {
            dispatch(setWallet(address))
            dispatch(showPopup({isOpen: false}));
            toast.success("Wallet Connected!");
        }
        dispatch(saveWallet('save', wallet, cbSetWallet))
    }
    const onClickHandler = async (provider) => {
        if(provider === 'mm'){
            await connectWallet("request", callback);
        }
    }
  return (
    <div className={style.container}>
        <div className={style.title}>Select Wallet</div>
        <div className={style.walletContainer}>
            {walletData.map((item, index) => {
                return (
                    <div className={style.wallet} key={index} onClick={() => onClickHandler(item.provider)}>
                        <img className={style.logoWallet} src={item.icon} alt={`logo ${item.title}`}/>
                        {item.title}
                    </div>
                )
            })}
        </div>
    </div>
  )
}

export default WalletList